import React from 'react';
import Tabs, { TTabItem } from '@/components/Tabs';
import { ScheduledIcon, ActionRequiredIcon, BatchHistoryIcon } from '@/components/Icons';
import { PaymentGroup, PaymentGroupEnum } from '../types/ManagePayments';
import { batchPaymentsPage } from '@/utils/translations';

interface PaymentsTabBarProps {
  activeTab: PaymentGroup;
  onChange: (tab: PaymentGroup) => void;
  counts: Record<PaymentGroup, number>;
  // Batch history has nothing to show for a profile without batch payment access (see
  // canAccessBatchPayments) - hidden rather than shown empty. Defaults to true so every other
  // caller/test keeps today's behaviour unchanged.
  showBatchHistory?: boolean;
}

const TAB_CONFIG: Array<{
  id: PaymentGroup;
  label: string;
  Icon: TTabItem<PaymentGroup>['Icon'];
  showCount: boolean;
}> = [
  {
    id: PaymentGroupEnum.SCHEDULED,
    label: batchPaymentsPage.tabs.scheduled,
    Icon: ScheduledIcon,
    showCount: true
  },
  {
    id: PaymentGroupEnum.ACTION_REQUIRED,
    label: batchPaymentsPage.tabs.actionRequired,
    Icon: ActionRequiredIcon,
    showCount: true
  },
  {
    id: PaymentGroupEnum.BATCH_HISTORY,
    label: batchPaymentsPage.tabs.batchHistory,
    Icon: BatchHistoryIcon,
    showCount: false
  }
];

const PaymentsTabBar: React.FC<PaymentsTabBarProps> = ({
  activeTab,
  onChange,
  counts,
  showBatchHistory = true
}) => {
  const tabs: TTabItem<PaymentGroup>[] = TAB_CONFIG.filter(
    ({ id }) => showBatchHistory || id !== PaymentGroupEnum.BATCH_HISTORY
  ).map(({ id, label, Icon, showCount }) => ({
    id,
    Icon,
    label: showCount ? `${label} (${counts[id]})` : label
  }));

  return <Tabs tabs={tabs} activeTab={activeTab} onChange={onChange} />;
};

export default PaymentsTabBar;
